module.exports = __webpack_public_path__ + "static/img/IMG_20160617_014702.a26439df.jpg";